import RelationshipMetadata from "../../RelationshipMetadata";

class AccountUserAccountUserWorkGroupRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AccountUserAccountUserWorkGroupRelationshipMetadata";
        this.parentEnterpriseComponent = "AccountUser";
        this.childEnterpriseComponent = "AccountUserWorkGroup";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default AccountUserAccountUserWorkGroupRelationshipMetadata;